import React from 'react'
//<i className='icon-down'/>
class ControlsTd extends React.Component {
  render() {
    return <td key={this.props.index}>{this.props.data} <i className={this.props.icon}> </i></td>;

  }
}
class ProductCategoryRow extends React.Component {
  render() {
    return <tr><th colSpan={this.props.count}>{this.props.category}</th></tr>;
  }
}
class TheadTitles extends React.Component {
  render() {
    let {date} = this.props
    date = date.split(' ')
    let hour = date[1]
    date = date[0]
    
    return <th> <br/><span className='date'>{date}</span><span className='hour'>{hour}</span></th>;
  }
}
class ProductRow extends React.Component {
  render() {
    let td = []
    let count =this.props.data.count
    let control = this.props.data.control
    let icon = this.props.data.className
    control.forEach((data, index) => {
      let tmp = icon[index]? icon[index] : ''
      td.push(<ControlsTd index={index} key={index} data={data} icon={tmp}/>)
    })
    var name = this.props.data.stocked ?
      this.props.data.name :
      <span style={{color: 'red'}}>
        {this.props.data.name}
      </span>;
    return (
      <tr>
        <td>{name}</td>
        {td}
      </tr>
    );
  }
}
export default class TableComponent extends React.Component {
render() {
   var rows = []
   var thead = []
   var lastCategory = null
   let count = this.props.theads.count + 1
   let dates = this.props.theads.dates

   for(let i = 0; i< count; i ++){

     thead.push(<TheadTitles key={i} date={dates[i]}/>)

   }

   this.props.data.forEach(function(data) {
     if (data.category !== lastCategory) {
       rows.push(<ProductCategoryRow category={data.category} key={data.category} count={count} />);
     }
     rows.push(<ProductRow data={data} key={data.name} count={count} />);
     lastCategory = data.category;
   });
   return (

     <table className='tableDataControl'>
       <thead>
         <tr>
           {thead}
         </tr>
       </thead>
       <tbody>{rows}</tbody>
     </table>
   );
 }
}


// WEBPACK FOOTER //
// ./src/components/HealthTable/TableComponent.js